<template>
  <div
    class="modal fade"
    id="panelResolucion"
    tabindex="-1"
    aria-labelledby="panelResolucionLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" style="max-width:700px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="panelResolucionLabel">Resolución</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <div v-for="cliente in operacion.clientes" :key="cliente.otro">
              <p class="size14">
                {{ $filters.CapitalizeFilter(cliente.nombre) }}
              </p>
            </div>
            <p class="size12">No. Folio {{ operacion.folio }}</p>
          </div>
          <div id="panelResolucion" class="container">
            <div id="cabeceraPanel" class="d-flex pt-3" style="padding-left: 12px; padding-right: 12px;">
              <div class="w-50 text-center align-self-center">
                <p class="size13">Integrante</p>
              </div>
              <div class="w-25 text-center align-self-center">
                <p class="size13">Votación</p>
              </div>
              <div class="w-25 text-center align-self-center">
                <p class="size13">Estatus Integrante</p>
              </div>
              <div class="text-center align-self-center" style="width: 30%">
                <p class="size13">Comentarios</p>
              </div>
            </div>
            <div class="d-flex">
                <div class="w-50">
                    <p class="nombre size13 d-flex align-items-center m-0" style="min-height: 60px" v-for="integrante in integrantes" :key="integrante">{{$filters.CapitalizeFilter(integrante.nombre)}}</p>
                </div>
                <div class="w-25">
                    <p class="d-flex align-items-center justify-content-center m-0" style="min-height: 60px" v-for="integrante in integrantes" :key="integrante" :class="obtenerColor(integrante.voto)"><i :class="obtenerIcono(integrante.voto)"></i></p>
                </div>
                <div class="w-25">
                    <p class="size13 d-flex align-items-center justify-content-center m-0" style="min-height: 60px" v-for="integrante in integrantes" :key="integrante">
                        <i :class="obtenerColorEstatus(integrante.asistencia)" class="bi bi-circle-fill me-2"></i>{{obtenerEstatus(integrante.asistencia)}}
                    </p>
                </div>
                <div class="ps-2" style="width: 30%">
                    <p class="nombre size13 d-flex align-items-center justify-content-center m-0" style="min-height: 60px" v-for="integrante in integrantes" :key="integrante">{{$filters.CapitalizeFilter(integrante.comentario)}}</p>
                </div>
            </div>
          </div>

          <div class="container mt-3">
            <div class="row conteo justify-content-between">
              <div class="col-md-7 text-center divResolucion d-flex align-items-center justify-content-center mt-3">
                <div class="row resolucion">
                  <div class="col-md-3">
                    <div>{{aprobadas}}</div>
                    <div class="size9">Aprobadas</div>
                  </div>
                  <div class="col-md-3">
                    <div>{{rechazadas}}</div>
                    <div class="size9">Rechazadas</div>
                  </div>
                  <div class="col-md-3">
                    <div>{{pendientes}}</div>
                    <div class="size9">Pendientes</div>
                  </div>
                  <div class="col-md-3">
                    <div>{{ausentes}}</div>
                    <div class="size9">Ausentes</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 textoBlanco  divResolucion  text-center d-flex align-items-center justify-content-center mt-3" :class="obtenerColorResolucion(resolucion)" style="min-width:180px">
                <div class="row p-2">
                  <div class="col-md-3 textoBlanco size30">
                    <i :class="obtenerIconoResolcion(resolucion)"></i>
                  </div>
                  <div class="col-md-9" >
                    <div class="size9">Decisión del comité:</div>
                    <div class="">{{resolucion}}</div>
                    <div v-if="resultadoVotaciones.votoCalidad" class="size9">Por voto de calidad de {{resultadoVotaciones.usuarioVotoCalidad}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="size14">Condiciones de la Operación:</p>
            <div class="input-group mb-3">
              <Multiselect v-if="operacion.enumEstatusOperacion != 3"
                v-model="selectCondicionantes.value"
                v-bind="selectCondicionantes"
              ></Multiselect>
              <Multiselect v-else
                v-model="selectCondicionantes.value"
                v-bind="selectCondicionantes"
                disabled
              ></Multiselect>
            </div>
          </div>
          <div class="text-center mt-3 mb-3">
            <button v-if="operacion.enumEstatusOperacion != 3" type="button" class="btn btn-info rounded-pill"  data-bs-dismiss="modal" @click="actualizarCondiciones()">
              Actualizar condiciones
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="operacion.enumEstatusOperacion != 3" type="button" class="btn btn-primary rounded-pill"  data-bs-dismiss="modal" @click="guardarResolucion()">
            Guardar resolución
          </button>
           <button v-else type="button" class="btn btn-primary rounded-pill" data-bs-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import * as bootstrap from 'bootstrap'

export default defineComponent({
  name: "ModalResolucion",
      components: {
    },

  props: {
    operacion: Object,
    catalogoCondicionantes: Array,
    resultadoVotaciones: Object
  },
  data() {
      return{
        resolucion: "",
        selectCondicionantes: {
    	      mode: 'tags',
            value: [],
            closeOnSelect: false,
            options: [],
            searchable: true,
            createOption: true
        },
        aprobadas: 0,
        rechazadas: 0,
        pendientes: 0,
        ausentes: 0
      }
    },
    created() {},
   watch: {
        catalogoCondicionantes: function(newVal, oldVal) { 
          let catalogo = newVal.map(c => ({ value: c.condicionanteOperacionId, label: c.nombre }));
          this.selectCondicionantes.options = catalogo;
        },
       resultadoVotaciones: function(newVal, oldVal){
          let condiciones = newVal.condiciones.map(c => ( c.condicionanteOperacionId ));
          this.selectCondicionantes.value = condiciones;

          this.integrantes = newVal.integrantes;
          if(typeof(this.integrantes) === 'object')
          {
            this.aprobadas = this.integrantes.map((i) => i.voto).filter(x => x == 0).length;
            this.rechazadas = this.integrantes.map((i) => i.voto).filter(x => x == 1).length;
            this.pendientes = this.integrantes.map((i) => i.voto).filter(x => x == 2).length;
            let asistencias = this.integrantes.map((i) => i.asistencia).filter(x => x === true)
            this.ausentes = this.integrantes.length - asistencias.length;
          }
          this.resolucion = newVal.resolucion;
       }
  },
  computed:{

  },
  methods :{
        async guardarResolucion() {
          var params = {};
            params.OperacionId = this.$route.params.id;
            params.Condiciones = this.selectCondicionantes.value;

        await this.axios
            .post(`VotacionComiteCredito/GuardarResolucion`,params)
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                  if(this.respuesta.resultado != null)
                   {
                    this.resolucion = this.respuesta.resultado.resolucion;
                    this.integrantes = this.respuesta.resultado.integrantes;
                    this.operacion.enumEstatusOperacion = this.respuesta.resultado.estatusOperacion;
                    this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje});
                   }
                }
                this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje});
            })
            .catch((error) => {
              this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        },

        async actualizarCondiciones(){
          var params = {};
            params.OperacionId = this.$route.params.id;
            params.Condiciones = this.selectCondicionantes.value;
          await this.axios
            .post("VotacionComiteCredito/ActualizarCondiciones", params)
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                  if(this.respuesta.resultado != null)
                   {
                     this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje});
                   }
                }
                this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje});
            })
            .catch((error) => {
              this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        },

        obtenerColor(valor){
          if(valor==0){
            return 'textoVerde'
          }
          if(valor==1){
            return 'textoRojo'
          }
          if(valor==2){
            return 'textoAzul'
          }

          return 'textoGris'
        },
        obtenerIcono(valor){
        if(valor==0){
                  return 'bi bi-check-circle'
                }
                if(valor==1){
                  return 'bi bi-x-circle'
                }
                if(valor==2){
                  return 'bi bi-dash-circle'
                }

                return 'bi bi-slash-circle'
              },
              
              obtenerColorEstatus(valor){
                if(valor==1){
                  return 'textoVerde'
                }
                if(valor==0){
                  return 'textoGris'
                }
               },
               obtenerEstatus(valor){
                if(valor==1){
                  return 'Activo'
                }
                if(valor==0){
                  return 'Ausente'
                }
               },
               obtenerColorResolucion(valor){
                 if(valor=='APROBADA'){
                  return 'verde'
                }
                if(valor=='RECHAZADA'){
                  return 'rojo'
                }
                if(valor=='PENDIENTE'){
                  return 'azul'
                }
                return 'gris'
               },
               obtenerIconoResolcion(valor){
                if(valor=='APROBADA'){
                  return 'bi bi-check-circle'
                }
                if(valor=='RECHAZADA'){
                  return 'bi bi-x-circle'
                }
                if(valor=='PENDIENTE'){
                  return 'bi bi-dash-circle'
                }

                return 'bi bi-slash-circle'
              }

  }
});
    

</script>

<style scoped>
#panelResolucion,
.divResolucion {
  border-radius: 15px;
  box-shadow: 0px 2px 5px -1px #b2b2b2;
  /* white-space: nowrap; */
  /* display: inline-block; */
}

.wrapper {
  display: flex;
  flex-wrap: nowrap;
  /* border: 5px solid green; */
  /* flex-direction: column; */
  flex-direction: row;
  width: max-content;
  margin: 0px;
  padding: 1px;
}
#cabeceraPanel {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  margin-left: -12px;
  margin-right: -12px;
  background-color: #eceff2;
}

h5 {
  font-family: Montserrat;
  font-weight: 700;
  font-style: normal;
  font-size: 17px;
  line-height: 20px;
  color: #4d4f5c;
}

p {
  font-family: Montserrat;
  font-weight: 700;
  font-style: normal;
  line-height: 18px;
  color: #4d4f5c;
}

.resolucion {
  font-family: Montserrat;
  font-weight: 700;
  font-style: normal;
  line-height: 18px;
  color: #4d4f5c;
}

.conteo {
  min-height: 100px;
}

.textoVerde {
  color: #17ad61;
}

.textoRojo {
  color: #ff7285;
}

.textoAzul {
  color: #568ffe;
}

.textoGris {
  color: #b9d1e9;
}

.textoBlanco {
  color: snow;
}

.verde {
  background-color: #17ad61;
  color: snow;
}

.rojo {
  background-color: #ff7285;
  color: snow;
}

.azul {
  background-color: #568ffe;
  color: snow;
}
.gris {
  background-color: #b9d1e9;
  color: snow;
}

.nombre {
  font-weight: 400;
}

.size30 {
  font-size: 30px;
}

.size14 {
  font-size: 14px;
}

.size12 {
  font-size: 12px;
}

.size13 {
  font-size: 13px;
}

.size9 {
  font-size: 9px;
}
</style>
